import { IconButton, IconButtonProps } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export const DeleteNode: React.FC<IconButtonProps> = (
  props
) => {
  return (
    <IconButton {...props}>
      <DeleteIcon />
    </IconButton>
  );
};

DeleteNode.defaultProps = {
  size: 'small',
};
